import { render, staticRenderFns } from "./EventCategoryGroupEdit.vue?vue&type=template&id=1516f04a"
import script from "./EventCategoryGroupEdit.js?vue&type=script&lang=js&external"
export * from "./EventCategoryGroupEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports